import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular
} from '@ionic/angular/standalone';

import { appRoutes } from './app/app.routes';
import { AppComponent } from './app/app.component';

// Import StatusBar and NavigationBar plugin
import { StatusBar, Style } from '@capacitor/status-bar';

import { addIcons } from 'ionicons';
import { flashlightOutline, cameraReverseOutline, closeOutline, qrCodeOutline, createOutline, timeOutline, openOutline, addCircleOutline, trashOutline } from 'ionicons/icons';
import { Capacitor } from '@capacitor/core';
import { provideHttpClient } from '@angular/common/http';

addIcons({
  'flashlight-outline': flashlightOutline,
  'camera-reverse-outline': cameraReverseOutline,
  'close-outline': closeOutline,
  'qr-code-outline': qrCodeOutline,
  'create-outline': createOutline,
  'time-outline': timeOutline,
  'open-outline': openOutline,
  'add-circle-outline': addCircleOutline,
  'trash-outline': trashOutline,
});

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
  ],
}).then(() => {
  // Set status bar overlay to false and define style
  if(Capacitor.isNativePlatform()) {
    // StatusBar.setBackgroundColor({ color: '#ffffff' }).catch(console.warn);
    StatusBar.setOverlaysWebView({ overlay: false }).catch(console.warn);
    StatusBar.setStyle({ style: Style.Dark }).catch(console.warn);  //changed from dark to default

  }
}).catch(console.error);
